import React from "react";
import { Oval } from "react-loader-spinner";
import './Loader.css'

const Loader = () => {
  return (
    <>
      <div className="global-loader">
        <Oval
          ariaLabel="loading-indicator"
          height={100}
          width={100}
          strokeWidth={5}
          color="#fff"
          className="global-loader-inner"
          secondaryColor="#00D9FA"
        />
      </div>
    </>
  );
};

export default Loader;
